import { useState, useCallback } from 'react';
import { BlockInsertionService } from '../services/blockInsertionService';

export const useBlockPlaceholders = () => {
  const [placeholderCount, setPlaceholderCount] = useState(0);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const refreshPlaceholders = useCallback(async () => {
    setIsRefreshing(true);
    try {
      const count = await BlockInsertionService.countBlockPlaceholders();
      setPlaceholderCount(count);
    } catch (error) {
      console.error('Error refreshing placeholders:', error);
    } finally {
      setIsRefreshing(false);
    }
  }, []);

  return {
    placeholderCount,
    isRefreshing,
    refreshPlaceholders
  };
};



